import React from "react";

const Image = ({ imageURL, srcSet, styleSheet, alt }) => {
  const srcSetAttr = srcSet
    ? { srcset: srcSet.map((url, i) => `${url} ${i + 2}x`) }
    : undefined;
  return (
    <img
      className={styleSheet}
      style={{ maxWidth: "100%" }}
      src={imageURL}
      {...srcSetAttr}
      alt={alt}
    />
  );
};

export default Image;
